/**
 * Product session API base — must match invokeApi / fetchJson routing.
 * Sites admin calls the API host directly (same as Learnix; no SPA /api rewrite).
 * Unset API_BASE_URL → same-origin /api (Vite proxy in local only).
 */

export function getSitesProductApiBase(origin) {
  const trimmed = String(origin || '').replace(/\/$/, '');
  if (!trimmed) return '/api';
  return `${trimmed}/api`;
}

export function createSitesProductApiConfig(origin) {
  return {
    apiBase: getSitesProductApiBase(origin),
    csrf: true,
    csrfPath: '/general_routes/csrf_token',
  };
}

/** Join a caller path (`/api/v1/...` or `/v1/...`) onto the product API base. */
export function productApiUrl(path, apiBase) {
  const base = String(apiBase || '/api').replace(/\/$/, '');
  let p = path.startsWith('/') ? path : `/${path}`;
  if (p.startsWith('/api/')) {
    p = p.slice(4);
  } else if (p === '/api') {
    p = '';
  }
  return `${base}${p}`;
}
